// src/app/api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

type paths = import('../__api/_apiConfig/api-types').paths;

type HealthResponse = paths['/v1/health']['get']['responses']['200']['content']['application/json'];
type ClientListResponse = paths['/v1/client']['get']['responses']['200']['content']['application/json'];
type ClientDetailResponse = paths['/v1/client/{id}']['get']['responses']['200']['content']['application/json'];
type ClientCreateRequest = paths['/v1/client']['post']['requestBody']['content']['application/json'];
type DashboardDataResponse = paths['/v1/dashboard/info']['get']['responses']['200']['content']['application/json'];

@Injectable({ providedIn: 'root' })
export class ApiService {
  private base = 'https://api.voyjaleas.com';
  
  constructor(private http: HttpClient) {}

  headers(client: 'website'|'dashboard'|'webapp'|'landing', apiKey?: string) {
    const h: Record<string,string> = { 'X-Client': client };
    if (apiKey) h['X-API-Key'] = apiKey;
    return new HttpHeaders(h);
  }

  health(client: 'website'|'dashboard'|'webapp'|'landing', apiKey?: string) {
    return this.http.get<HealthResponse>(`${this.base}/v1/health`, { headers: this.headers(client, apiKey) });
  }

  //CLIENTS
  getClientDetails(id: number,client:'website'|'dashboard'='website') {
  return this.http.get<ClientDetailResponse>(`${this.base}/v1/client/${id}`, { headers: this.headers(client) });
}

  listClients(limit=20, offset=0, client:'website'|'dashboard'='website', apiKey?: string) {
    return this.http.get<ClientListResponse>(`${this.base}/v1/client`, { params: { limit: String(limit), offset: String(offset) }, headers: this.headers(client, apiKey) });
  }

  createClient(body: ClientCreateRequest, token: string, client:'dashboard'='dashboard', apiKey?: string) {
    const headers = this.headers(client, apiKey).set('Authorization', `Bearer ${token}`).set('Content-Type','application/json');
    return this.http.post<{id:number}>(`${this.base}/v1/client`, body, { headers });
  }

  getClientDashboardData(client:'website'|'dashboard'='website', apiKey?: string) {
    return this.http.get<DashboardDataResponse>(`${this.base}/v1/dashboard/info`, { params: {}, headers: this.headers(client, apiKey) });
  }
}
